var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEpicLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69035",
    "data-name": "Group 69035",
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.054,
    height: 137.437,
    viewBox: "0 0 138.054 137.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68971",
    "data-name": "Group 68971",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68972",
    "data-name": "Group 68972",
    transform: "translate(0 41.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68963",
    "data-name": "Group 68963",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    fill: "#a0bdfc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 131.0542907714844 95.11373901367188 L 7.00001049041748 95.11373901367188 C 3.691592216491699 95.11373901367188 1.00001049041748 92.42215728759766 1.00001049041748 89.11373901367188 L 1.00001049041748 6.999996662139893 C 1.00001049041748 3.69157862663269 3.691592216491699 0.9999967813491821 7.00001049041748 0.9999967813491821 L 131.0542907714844 0.9999967813491821 C 134.3627014160156 0.9999967813491821 137.0542907714844 3.69157862663269 137.0542907714844 6.999996662139893 L 137.0542907714844 89.11373901367188 C 137.0542907714844 92.42215728759766 134.3627014160156 95.11373901367188 131.0542907714844 95.11373901367188 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7 1.999992370605469 C 4.242996215820312 1.999992370605469 2 4.242988586425781 2 6.999992370605469 L 2 89.11373138427734 C 2 91.8707275390625 4.242996215820312 94.11373138427734 7 94.11373138427734 L 131.0542755126953 94.11373138427734 C 133.811279296875 94.11373138427734 136.0542755126953 91.8707275390625 136.0542755126953 89.11373138427734 L 136.0542755126953 6.999992370605469 C 136.0542755126953 4.242988586425781 133.811279296875 1.999992370605469 131.0542755126953 1.999992370605469 L 7 1.999992370605469 M 7 -7.62939453125e-06 L 131.0542755126953 -7.62939453125e-06 C 134.9202728271484 -7.62939453125e-06 138.0542755126953 3.134010314941406 138.0542755126953 6.999992370605469 L 138.0542755126953 89.11373138427734 C 138.0542755126953 92.97972869873047 134.9202728271484 96.11373138427734 131.0542755126953 96.11373138427734 L 7 96.11373138427734 C 3.134002685546875 96.11373138427734 0 92.97972869873047 0 89.11373138427734 L 0 6.999992370605469 C 0 3.134010314941406 3.134002685546875 -7.62939453125e-06 7 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#407bf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    transform: "translate(5.47 4.52)",
    fill: "#454545"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.240364074707 86.72445678710938 L 6.99999475479126 86.72445678710938 C 3.415878295898438 86.72445678710938 0.4999949038028717 83.80857086181641 0.4999949038028717 80.22445678710938 L 0.4999949038028717 7.000008106231689 C 0.4999949038028717 3.415891170501709 3.415878295898438 0.5000079274177551 6.99999475479126 0.5000079274177551 L 119.240364074707 0.5000079274177551 C 122.8244781494141 0.5000079274177551 125.740364074707 3.415891170501709 125.740364074707 7.000008106231689 L 125.740364074707 80.22445678710938 C 125.740364074707 83.80857086181641 122.8244781494141 86.72445678710938 119.240364074707 86.72445678710938 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.999992370605469 0.9999923706054688 C 3.691581726074219 0.9999923706054688 0.9999923706054688 3.691574096679688 0.9999923706054688 6.999992370605469 L 0.9999923706054688 80.22444152832031 C 0.9999923706054688 83.53285980224609 3.691581726074219 86.22444152832031 6.999992370605469 86.22444152832031 L 119.240364074707 86.22444152832031 C 122.5487747192383 86.22444152832031 125.240364074707 83.53285980224609 125.240364074707 80.22444152832031 L 125.240364074707 6.999992370605469 C 125.240364074707 3.691574096679688 122.5487747192383 0.9999923706054688 119.240364074707 0.9999923706054688 L 6.999992370605469 0.9999923706054688 M 6.999992370605469 -7.62939453125e-06 L 119.240364074707 -7.62939453125e-06 C 123.1063461303711 -7.62939453125e-06 126.240364074707 3.134010314941406 126.240364074707 6.999992370605469 L 126.240364074707 80.22444152832031 C 126.240364074707 84.09043884277344 123.1063461303711 87.22444152832031 119.240364074707 87.22444152832031 L 6.999992370605469 87.22444152832031 C 3.133995056152344 87.22444152832031 -7.62939453125e-06 84.09043884277344 -7.62939453125e-06 80.22444152832031 L -7.62939453125e-06 6.999992370605469 C -7.62939453125e-06 3.134010314941406 3.133995056152344 -7.62939453125e-06 6.999992370605469 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#407bf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69029",
    "data-name": "Group 69029",
    transform: "translate(15.368 26.748)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17305",
    "data-name": "Rectangle 17305",
    width: 107.318,
    height: 7.373,
    rx: 3.686,
    transform: "translate(0)",
    fill: "#c9d3e7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 2.212,
    cy: 2.212,
    rx: 2.212,
    ry: 2.212,
    transform: "translate(3.686 1.474)",
    fill: "#407bf9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 2.212,
    cy: 2.212,
    rx: 2.212,
    ry: 2.212,
    transform: "translate(9.585 1.474)",
    fill: "#407bf9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 2.212,
    cy: 2.212,
    rx: 2.212,
    ry: 2.212,
    transform: "translate(18.467 1.474)",
    fill: "#407bf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68970",
    "data-name": "Group 68970",
    transform: "translate(16.103 43.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17307",
    "data-name": "Rectangle 17307",
    transform: "translate(0 0)",
    fill: "#5a5a5a",
    stroke: "#407bf9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.541,
    height: 40.204,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 104.541,
    height: 39.204,
    rx: 2.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69033",
    "data-name": "Group 69033",
    transform: "translate(40.425 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    transform: "translate(0)",
    fill: "#a0bdfc",
    stroke: "#407bf9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.366,
    cy: 30.848,
    rx: 30.366,
    ry: 30.848,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.366,
    cy: 30.848,
    rx: 29.366,
    ry: 29.848,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69031",
    "data-name": "Group 69031",
    transform: "translate(3.854 3.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    transform: "translate(0 0)",
    fill: "#454545",
    stroke: "#a0bdfc",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.51,
    cy: 26.51,
    r: 26.51,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.51,
    cy: 26.51,
    r: 26.01,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M16.479,18.539A9.27,9.27,0,1,0,7.21,9.27,9.272,9.272,0,0,0,16.479,18.539Zm8.24,2.06H21.172a11.206,11.206,0,0,1-9.385,0H8.24A8.239,8.239,0,0,0,0,28.839v1.03a3.091,3.091,0,0,0,3.09,3.09H29.868a3.091,3.091,0,0,0,3.09-3.09v-1.03A8.239,8.239,0,0,0,24.719,20.6Z",
    transform: "translate(10.089 10.776)",
    fill: "#a0bdfc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicLogin);
export default __webpack_public_path__ + "static/media/Epic_login.0ae330c40247f947aeec1094690abc84.svg";
export { ForwardRef as ReactComponent };